import {ReactNode} from "react";
import {OtsDateTimePicker} from "./OtsDateTimePicker";

export type OtsDatePickerProps = {
  label: ReactNode;
  /** The chosen day, in the viewer's local calendar. */
  value?: Date;
  onChange: (value?: Date) => void;
  description?: ReactNode;
  error?: ReactNode;
  /** Earliest and latest days that can be picked. */
  min?: Date;
  max?: Date;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  size?: "compact" | "default";
  placeholder?: string;
  /** Keeps the label for assistive technology only, for a picker that sits inline in a toolbar. */
  hideLabel?: boolean;
  className?: string;
  id?: string;
};

/** Picks a day with no time of day: the foundation date-time picker's calendar, on local dates. */
export const OtsDatePicker = ({value, onChange, min, max, placeholder = "Select a date", ...props}: OtsDatePickerProps) => (
  <OtsDateTimePicker
    {...props}
    includeTime={false}
    placeholder={placeholder}
    value={value?.getTime()}
    min={min?.getTime()}
    max={max?.getTime()}
    onChange={(next) => {
      if (next == null) return onChange(undefined);
      const day = new Date(next);
      onChange(new Date(day.getFullYear(), day.getMonth(), day.getDate()));
    }}/>
);
